<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">门店管理>就餐时间设置</div>
		<div class="first_line">
			<el-button type="primary" size="small" @click="addEatTimePop()">新建组</el-button>
		</div>
		<el-tabs>
			<el-tab-pane label="固定时间点">
				<div>
					<el-table :cell-style="{'text-align':'center'}"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
						:data="Data1" tooltip-effect="dark" style="width: 100%">
						<el-table-column prop="title" label="组名">
						</el-table-column>
						<el-table-column label="中午就餐时间">
							<template slot-scope="scope">
								{{scope.row.lunchStartTime}}-{{scope.row.lunchEndTime}}
							</template>
						</el-table-column>
						<el-table-column label="晚上就餐时间">
							<template slot-scope="scope">
								{{scope.row.dinnerStartTime}}-{{scope.row.dinnerEndTime}}
							</template>
						</el-table-column>
						<el-table-column label="包含发型师">
							<template slot-scope="scope">
								<div style="display: flex;flex-wrap: wrap;">
									<div v-for=" i in workerList" v-if="i.eatTimeId==scope.row.id" tabindex="item.index"
										class="divBack">
										<el-tag :closable="jidongShow" @close="delEatTime(i.id)"
											@click="check(i.id,i.name,i.telphone) " class=" jidongbtn">{{i.name}}
										</el-tag>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="是否启用">
							<template slot-scope="scope">
								<el-switch on-value="true" off_value="false" v-model="scope.row.status"
									@change="OnOff(scope.row)">
								</el-switch>
							</template>
						</el-table-column>
						<el-table-column width="180" label="编辑">
							<template slot-scope="scope">
								<div>
									<el-button type="text" @click="addEatTimePop(scope.row)">编辑组</el-button>
									<el-button type="text" @click="openYouhui(scope.row)">管理发型师</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-tab-pane>
			<el-tab-pane label="固定时间段">
				<div>
					<el-table :cell-style="{'text-align':'center'}"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
						:data="Data2" tooltip-effect="dark" style="width: 100%">
						<el-table-column prop="title" label="组名">
						</el-table-column>
						<el-table-column label="中午就餐时间">
							<template slot-scope="scope">
								{{scope.row.lunchStartTime}}-{{scope.row.lunchEndTime}}
							</template>
						</el-table-column>
						<el-table-column label="晚上就餐时间">
							<template slot-scope="scope">
								{{scope.row.dinnerStartTime}}-{{scope.row.dinnerEndTime}}
							</template>
						</el-table-column>
						<el-table-column label="包含发型师">
							<template slot-scope="scope">
								<div style="display: flex;flex-wrap: wrap;">
									<div v-for=" i in workerList" v-if="i.eatTimeId==scope.row.id" tabindex="item.index"
										class="divBack">
										<el-tag :closable="jidongShow" @close="delEatTime(i.id)"
											@click="check(i.id,i.name,i.telphone) " class=" jidongbtn">{{i.name}}
										</el-tag>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="是否启用">
							<template slot-scope="scope">
								<el-switch on-value="true" off_value="false" v-model="scope.row.status"
									@change="OnOff(scope.row)">
								</el-switch>
							</template>
						</el-table-column>
						<el-table-column width="180" label="编辑">
							<template slot-scope="scope">
								<div>
									<el-button type="text" @click="addEatTimePop(scope.row)">编辑组</el-button>
									<el-button type="text" @click="openYouhui(scope.row)">管理发型师</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!-- 新建时间组 -->
		<el-dialog title="新建时间组" :visible.sync="addpop" width="30%">
			<el-form ref="form" :model="addDataList" label-width="100px" label-position="left">
				<el-form-item label="类型">
					<div style="display: flex;margin-top:15px;">
						<el-radio v-model="addDataList.type" label="0">时间点</el-radio>
						<el-radio v-model="addDataList.type" label="1">时间段</el-radio>
					</div>
				</el-form-item>
				<el-form-item label="组名">
					<el-input size="medium" v-model="addDataList.title" style="width:70%;"
						placeholder="请输入组名"></el-input>
				</el-form-item>
				<el-form-item label="午餐时间">
					<templete>
						<el-select v-model="addDataList.lunchStartTime" placeholder="午餐开始时间" clearable size="small"
							class="wtime">
							<el-option v-for="item in timeLunchStartList" :key="item.value" :value="item.value"
								:label="item.value"></el-option>
						</el-select>
						~
						<el-select v-model="addDataList.lunchEndTime" placeholder="午餐结束时间" clearable size="small"
							class="wtime">
							<el-option v-for="item in timeLunchEndList" :key="item.value" :value="item.value"
								:label="item.value"></el-option>
						</el-select>
					</templete>
				</el-form-item>
				<el-form-item label="晚餐时间">
					<el-select v-model="addDataList.dinnerStartTime" placeholder="晚餐开始时间" clearable size="small"
						class="wtime">
						<el-option v-for="item in timeDinnerStartList" :key="item.value" :value="item.value"
							:label="item.value"></el-option>
					</el-select>
					~
					<el-select v-model="addDataList.dinnerEndTime" placeholder="晚餐结束时间" clearable size="small"
						class="wtime">
						<el-option v-for="item in timeDinnerEndList" :key="item.value" :value="item.value"
							:label="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div class="add_botom">
				<div class="add_botom_nei">
					<el-button size="small">取消</el-button>
					<el-button size="small" type="primary" @click="addEatTime()">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 管理发型师 -->
		<el-dialog title="管理发型师" :visible.sync="dialog_addWorker" width="40%">
			<input type="text" v-model="workerList1.name" @keydown.enter="getWorkerList1(workerList1.name)"
				placeholder="输入发型师姓名" style="font-size:15px;padding: 5px;margin-bottom:20px;">
			<el-button type="primary" size="small" style="margin-left: 10px;"
				@click="addWorker(jiDongcheck)">添加</el-button>
			<el-button type="text" size="middle" class="red" @click="jidongShow=!jidongShow">移除</el-button>
			<div>
				<el-radio-group v-model="radio">
					<el-radio v-for="j in workerList1" v-if="j.status!=8"
						@click.native.prevent="check(j.id,j.name,j.phone)">
						{{j.name}}———{{j.storeName}}
					</el-radio>
				</el-radio-group>
			</div>
			<div style="background-color: #fbfbfb;min-height: 100px; padding: 0 10 0 10;margin-top: 10px;">
				<div style="display: flex;flex-wrap: wrap;">
					<div v-for=" i in workerList" v-if="i.eatTimeId==eId" tabindex="item.index" class="divBack">
						<el-tag style="color: #000; margin: 5px; border: #fafafa;" :closable="jidongShow"
							@close="delEatTime(i.id)" @click="check(i.id,i.name,i.telphone) "
							class=" jidongbtn">{{i.name}}
						</el-tag>
					</div>
				</div>
			</div>
			<el-button type="info" style="margin-left: 40%; margin-top: 15px;"
				@click="dialog_addWorker=false">完成</el-button>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialog_addWorker: false,
				addpop: false,
				jidongShow: false,
				jiDongcheck: undefined,
				eId: undefined,
				status: undefined,
				tableData: [],
				Data1: [],
				Data2: [],
				radio: null,
				workerList1: {
					id: '',
					name: "",
					storeName: "",
					eatTimeId: '',
					status: "",
				},
				workerList: {
					id: '',
					name: "",
					storeName: "",
					eatTimeId: '',
				},
				addDataList: {
					status: true,
					type: "0",
					title: "",
					lunchStartTime: "",
					lunchEndTime: "",
					dinnerStartTime: "",
					dinnerEndTime: ""
				},
				timeLunchStartList: [{
					id: 4,
					value: '12:00:00'
				}, {
					id: 5,
					value: '12:15:00'
				}, {
					id: 6,
					value: '12:30:00'
				}, {
					id: 0,
					value: '13:00:00'
				}, {
					id: 1,
					value: '13:15:00'
				}, {
					id: 2,
					value: '13:30:00'
				}, {
					id: 3,
					value: '13:45:00'
				}, ],
				timeLunchEndList: [{
					id: 5,
					value: '12:15:00'
				}, {
					id: 6,
					value: '12:30:00'
				}, {
					id: 7,
					value: '13:00:00'
				}, {
					id: 0,
					value: '13:15:00'
				}, {
					id: 1,
					value: '13:30:00'
				}, {
					id: 2,
					value: '13:45:00'
				}, {
					id: 3,
					value: '14:00:00'
				}],
				timeDinnerStartList: [{
					id: 0,
					value: '17:00:00'
				}, {
					id: 1,
					value: '17:15:00'
				}, {
					id: 2,
					value: '17:30:00'
				}, {
					id: 3,
					value: '18:00:00'
				}, {
					id: 4,
					value: '18:15:00'
				}, {
					id: 5,
					value: '18:30:00'
				}, {
					id: 6,
					value: '18:45:00'
				}, {
					id: 7,
					value: '19:00:00'
				}, {
					id: 8,
					value: '19:15:00'
				}, {
					id: 9,
					value: '19:30:00'
				}, ],
				timeDinnerEndList: [{
					id: 0,
					value: '17:30:00'
				}, {
					id: 1,
					value: '18:00:00'
				}, {
					id: 2,
					value: '18:15:00'
				}, {
					id: 3,
					value: '18:30:00'
				}, {
					id: 4,
					value: '18:45:00'
				}, {
					id: 5,
					value: '19:00:00'
				}, {
					id: 6,
					value: '19:15:00'
				}, {
					id: 7,
					value: '19:30:00'
				}, {
					id: 8,
					value: '20:00:00'
				}],
			};
		},
		mounted() {
			this.getlist()
			this.getWorkerList()
		},
		methods: {
			//查找发型师
			getWorkerList1(name) {
				this.workerList1.name = null;
				this.$http.get("dWorker/queryAll" + "?name=" + name).then(res => {
					this.workerList1 = res.body.data;
				})
			},
			OnOff(row) {
				if (row.status != this.status) {
					this.$http.post("dEatTime/edit", JSON.stringify(row)).then(res => {
						if (res.body.code == 200) {
							this.$message.success("修改成功!")
						}
					})
				}
				this.dialog_addWorker = false
			},
			delEatTime(id) {
				this.$confirm('移除该发型师, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log("删除")
					var a = {
						id: id,
						eatTimeId: 0
					}
					this.$http.post("dWorker/saveOrUpdate", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.$message.success("移除成功")
							this.getWorkerList()
						} else {
							this.$message.error("移除失败")
						}
					})
				})
			},
			// 获取门店列表
			getlist() {
				this.$http.get("dEatTime/list").then(
					function(res) {
						if (res.body.code == "200") {
							this.Data1 = res.body.data.filter(ele => ele.type == 0)
							this.Data2 = res.body.data.filter(ele => ele.type == 1)
						} else {
							this.$message.error("请求失败")
						}
					},
					function(err) {
						this.$message.error("请求失败")
					})
			},
			cancel() {
				this.dialog_addWorker = false;
			},
			addEatTimePop(row) {
				this.addpop = true;
				if (row != null) {
					this.addDataList = row
					this.addDataList.type = row.type.toString();
				} else {
					this.addDataList = {};
				}
			},
			addEatTime() {
				this.$http.post("dEatTime/edit", JSON.stringify(this.addDataList)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功!")
						this.getlist()
					}
				})
				this.addpop = false
			},
			addWorker(id) {
				var arr = {
					id: id,
					eatTimeId: this.eId
				}
				this.$http.post("dWorker/saveOrUpdate", JSON.stringify(arr)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("更改成功")
						this.getWorkerList()
					}
				})
			},
			check(id, name, telphone) {
				this.jiDongcheck = id
				this.tagName = name
				this.tagPhone = telphone
			},
			openYouhui(row) {
				this.dialog_addWorker = true;
				this.eId = row.id
				this.status = row.status
			},
			getWorkerList() {
				this.$http.get("dWorker/query?filterOut=1").then(res => {
					this.workerList = res.body.data;
				})
			},
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
		},
	};
</script>
<style lang="less" scoped>
	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.dialog-footer {
		display: inline-block;
		margin-right: 31%;
	}

	// 弹出框内容
	.dia_title {
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #525252;
	}

	.erwei {
		width: 157px;
		height: 157px;
		margin: 20px auto;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.downerwei {
		cursor: pointer;
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #409EFF;
	}

	.dialog-footer {
		margin-top: -10px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}
</style>